<div style="min-width: 500px !important; width: 500px !important;" class="bg-white overflow-hidden rounded-xl">

  <div class="p-8 py-12 flex flex-col items-center text-center">

    <div class="flex h-20 w-20 items-center justify-center rounded-full bg-red-50 mb-6">
      <span class="material-icons text-red-600 text-5xl">warning</span>
    </div>

    <h2 class="m-0 p-0 text-2xl font-bold text-slate-800 leading-tight">
      {{ data.title }}
    </h2>

    <p *ngIf="data.message" class="mt-4 text-base text-slate-500 leading-relaxed max-w-[90%]">
      {{ data.message }}
    </p>
  </div>

  <div class="flex justify-center gap-4 bg-gray-50/50 px-6 py-6 border-t border-red-50">
    <button
      type="button"
      class="min-w-[140px] rounded-md border border-slate-300 bg-white px-6 py-2.5 text-sm font-semibold text-slate-600 hover:bg-slate-50 transition-all shadow-sm"
      (click)="handleCancel()">
      Não
    </button>

    <button
      type="button"
      class="min-w-[140px] rounded-md bg-red-600 px-6 py-2.5 text-sm font-semibold text-white hover:bg-red-700 transition-all shadow-md"
      (click)="handleConfirm()">
      Sim
    </button>
  </div>
</div>
